import { Link } from "react-router-dom";

const Banner = ({ title, bgImage, breadcrumbs }) => {
  return (
    <section
      className="TitleBanner-sec"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "80px 0",
        color: "#fff",
        position: "relative",
      }}
    >
      <div className="container text-center">
        <h1 className="banner-title">{title}</h1>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            {breadcrumbs.map((crumb, index) => (
              <li
                key={index}
                className={`breadcrumb-item ${
                  index === breadcrumbs.length - 1 ? "active" : ""
                }`}
                aria-current={
                  index === breadcrumbs.length - 1 ? "page" : undefined
                }
              >
                {index === breadcrumbs.length - 1 ? crumb : <Link to={`/${crumb.toLowerCase().replace(/\s+/g, '-')}`}>{crumb}</Link>}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      <div className="overlay"></div>
    </section>
  );
};

export default Banner;
